(function(){
  function init(){
    var root=document.querySelector('.kk-prod');
    if(!root||!window.KKDATA){return;}
    var V=window.KKDATA.V||[];
    var opts=(window.KKDATA.opts||[]).slice();
    var form=document.getElementById('kkForm');
    var idInput=document.getElementById('kkVarId');
    var addBtn=document.getElementById('kkAdd');
    var priceEl=document.getElementById('kkPrice'), oldEl=document.getElementById('kkOld'), badgeEl=document.getElementById('kkBadge');
    var pFinal=document.getElementById('kkPriceFinal'), oFinal=document.getElementById('kkOldFinal'), addFinal=document.getElementById('kkAddFinal');
    var pSticky=document.getElementById('kkPriceSticky'), vSticky=document.getElementById('kkVarSticky'), addSticky=document.getElementById('kkAddSticky');

    function fmt(cents){ try{ return (cents/100).toLocaleString('da-DK',{minimumFractionDigits:2})+' kr'; }catch(e){ return (cents/100)+' kr'; } }
    function findVariant(){
      for(var i=0;i<V.length;i++){
        var ok=true;
        for(var j=0;j<opts.length;j++){ if(V[i].options[j]!==opts[j]){ ok=false; break; } }
        if(ok) return V[i];
      }
      return null;
    }
    function setBtn(b,avail){ if(!b)return; b.disabled=!avail; if(b.childNodes[0]&&b.childNodes[0].nodeType===3){ b.childNodes[0].nodeValue = avail?'Læg i kurv':'Udsolgt'; } }
    function update(){
      var v=findVariant();
      var avail=!!(v && v.available);
      setBtn(addBtn,avail); setBtn(addFinal,avail); setBtn(addSticky,avail);
      if(v){
        idInput.value=v.id;
        if(window.KKVIMG){ var imId=window.KKVIMG[String(v.id)]; if(imId){ var ipane=root.querySelector('.kkpane[data-img-id="'+imId+'"]'); if(ipane){ show(parseInt(ipane.getAttribute('data-i'),10)); } } }
        var pm=fmt(v.price);
        priceEl.textContent=pm; if(pFinal)pFinal.textContent=pm; if(pSticky)pSticky.textContent=pm;
        var sale=v.compare_at_price && v.compare_at_price>v.price;
        priceEl.classList.toggle('sale',!!sale);
        if(sale){
          var cm=fmt(v.compare_at_price);
          oldEl.style.display=''; oldEl.textContent=cm;
          badgeEl.style.display=''; badgeEl.textContent='SPAR '+Math.round((v.compare_at_price-v.price)*100/v.compare_at_price)+'%';
          if(oFinal){oFinal.style.display='';oFinal.textContent=cm;}
        } else {
          oldEl.style.display='none'; badgeEl.style.display='none'; if(oFinal)oFinal.style.display='none';
        }
        if(vSticky)vSticky.textContent=v.title;
      }
    }
    root.querySelectorAll('.size-btn').forEach(function(btn){
      btn.addEventListener('click',function(){
        if(btn.classList.contains('oos'))return;
        var pos=parseInt(btn.getAttribute('data-pos'),10)-1;
        opts[pos]=btn.getAttribute('data-val');
        var block=btn.closest('.opt-block');
        block.querySelectorAll('.size-btn').forEach(function(b){b.classList.remove('active');});
        btn.classList.add('active');
        var cur=block.querySelector('.opt-current'); if(cur)cur.innerHTML='— '+btn.getAttribute('data-val');
        update();
      });
    });
    root.querySelectorAll('.opt-block').forEach(function(block){
      var pos=parseInt(block.getAttribute('data-pos'),10)-1;
      block.querySelectorAll('.size-btn').forEach(function(btn){
        var val=btn.getAttribute('data-val'), any=false;
        for(var i=0;i<V.length;i++){ if(V[i].options[pos]===val && V[i].available){ any=true; break; } }
        if(!any) btn.classList.add('oos');
      });
    });

    var panes=root.querySelectorAll('.kkpane'), thumbs=root.querySelectorAll('.kkthumb'), counter=document.getElementById('kkCounter');
    var idx=0, n=panes.length;
    function show(i){ if(i<0)i=n-1; if(i>=n)i=0; idx=i;
      panes.forEach(function(p,k){p.classList.toggle('active',k===i);});
      thumbs.forEach(function(t,k){t.classList.toggle('active',k===i);});
      if(counter)counter.textContent=('0'+(i+1)).slice(-2)+' / '+('0'+n).slice(-2);
    }
    thumbs.forEach(function(t){t.addEventListener('click',function(){show(parseInt(t.getAttribute('data-i'),10));});});
    var pv=document.getElementById('kkPrev'),nx=document.getElementById('kkNext');
    if(pv)pv.addEventListener('click',function(){show(idx-1);});
    if(nx)nx.addEventListener('click',function(){show(idx+1);});

    var mainImg=document.getElementById('kkMain');
    if(mainImg){
      var tsx=0,tsy=0,trk=false;
      mainImg.addEventListener('touchstart',function(e){ if(e.touches.length!==1)return; tsx=e.touches[0].clientX; tsy=e.touches[0].clientY; trk=true; },{passive:true});
      mainImg.addEventListener('touchend',function(e){ if(!trk)return; trk=false; var t=e.changedTouches[0]; var dx=t.clientX-tsx, dy=t.clientY-tsy; if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)){ if(dx<0)show(idx+1); else show(idx-1); } },{passive:true});
    }

    root.querySelectorAll('.faq-q').forEach(function(q){q.addEventListener('click',function(){q.closest('.faq-item').classList.toggle('open');});});

    function submitForm(){ if(form){ if(form.requestSubmit)form.requestSubmit(); else form.submit(); } }
    if(addFinal)addFinal.addEventListener('click',function(){ if(!addFinal.disabled)submitForm(); });
    if(addSticky)addSticky.addEventListener('click',function(){ if(!addSticky.disabled)submitForm(); });

    var sticky=document.getElementById('kkSticky');
    if(sticky){
      document.body.appendChild(sticky);
      var kkSt=document.createElement('style');
      kkSt.textContent='.sticky-atc{position:fixed;left:0;right:0;bottom:0;z-index:90;background:var(--bg);border-top:1px solid var(--line);padding:14px 48px;transform:translateY(110%);transition:transform .35s cubic-bezier(0.7,0,0.2,1);}.sticky-atc.show{transform:translateY(0);}.sticky-atc-inner{max-width:1280px;margin:0 auto;display:grid;grid-template-columns:56px 1fr auto;gap:18px;align-items:center;}.sticky-atc .thumb{width:56px;height:72px;background:var(--media);position:relative;overflow:hidden;background-size:cover;background-position:center;}.sticky-atc .meta{display:flex;flex-direction:column;gap:2px;min-width:0;}.sticky-atc .pname{font-family:var(--serif);font-weight:400;font-size:17px;line-height:1.1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}.sticky-atc .pname em{font-style:italic;}.sticky-atc .ppair{display:flex;gap:14px;font-size:11.5px;color:var(--mute);letter-spacing:0.02em;}.sticky-atc .ppair .pp{color:var(--ink);font-variant-numeric:tabular-nums;}.sticky-atc .sa-btn{display:inline-flex;align-items:center;gap:14px;padding:14px 28px;background:#3F8F4F;color:#fff;font-size:11.5px;letter-spacing:0.24em;text-transform:uppercase;transition:background .25s ease;}.sticky-atc .sa-btn:hover:not([disabled]){background:#357A43;}.sticky-atc .sa-btn[disabled]{opacity:0.5;cursor:not-allowed;}@media(max-width:720px){.sticky-atc{padding:12px 20px;}.sticky-atc-inner{grid-template-columns:44px 1fr auto;gap:12px;}.sticky-atc .thumb{width:44px;height:56px;}.sticky-atc .pname{font-size:14px;}.sticky-atc .sa-btn{padding:12px 16px;font-size:10.5px;letter-spacing:0.18em;}}';
      document.head.appendChild(kkSt);
      window.addEventListener('scroll',function(){ sticky.classList.toggle('show', window.scrollY>700); });
    }

    // (9) drag-scroll on option carousels (mouse on desktop; touch is native)
    root.querySelectorAll('.size-grid').forEach(function(grid){
      var down=false,sx=0,ss=0,moved=false;
      grid.addEventListener('pointerdown',function(e){
        if(e.pointerType==='touch')return;
        down=true;moved=false;sx=e.clientX;ss=grid.scrollLeft;grid.classList.add('kk-dragging');
        try{grid.setPointerCapture(e.pointerId);}catch(_){}
      });
      grid.addEventListener('pointermove',function(e){
        if(!down)return;
        var dx=e.clientX-sx;
        if(Math.abs(dx)>3)moved=true;
        grid.scrollLeft=ss-dx;
      });
      function end(){down=false;grid.classList.remove('kk-dragging');}
      grid.addEventListener('pointerup',end);
      grid.addEventListener('pointercancel',end);
      grid.addEventListener('click',function(e){ if(moved){e.preventDefault();e.stopPropagation();moved=false;} },true);
    });

    update();
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',init); } else { init(); }
})();
